module.exports = __webpack_public_path__ + "img/极客数据团队-中层.e6293164.png";